import styled, { css } from "styled-components";

export const CubeBannerBox = styled.section`
	display: grid;
	grid-template-rows: repeat(2, 50%);
	grid-auto-flow: column;
	padding: 1rem 0 0.75rem 0.75rem;

	img {
		max-height: 100%;
		max-width: 100%;
	}
	&::-webkit-scrollbar {
		display: none;
	}
	@keyframes AzureDragon {
		0% {
			transform: translateY(0);
		}
		9.37% {
			transform: translateY(-0.3125rem);
		}
		18.75% {
			transform: translateY(0);
		}
		21.25% {
			transform: scale(1.25);
		}
		23.75% {
			transform: scale(1.2);
		}
		26.25% {
			transform: scale(1.22);
		}
		28.75% {
			transform: scale(1.2);
		}
		31.25% {
			transform: scale(1.2);
		}
		33.75% {
			transform: scale(0.95);
		}
		36.25% {
			transform: scale(1);
		}
		38.75% {
			transform: scale(0.98);
		}
		41.25% {
			transform: scale(1);
		}
		43.75% {
			transform: scale(1);
		}
		46.25% {
			transform: scale(1.25);
		}
		48.75% {
			transform: scale(1.2);
		}
		51.25% {
			transform: scale(1.22);
		}
		53.75% {
			transform: scale(1.2);
		}
		56.25% {
			transform: scale(1.2);
		}
		58.75% {
			transform: scale(0.95);
		}
		61.25% {
			transform: scale(1);
		}
		63.75% {
			transform: scale(0.98);
		}
		66.25% {
			transform: scale(1);
		}
		68.75% {
			transform: scale(1);
		}
		71.25% {
			transform: scale(1.25);
		}
		73.75% {
			transform: scale(1.2);
		}
		76.25% {
			transform: scale(1.22);
		}
		78.75% {
			transform: scale(1.2);
		}
		81.25% {
			transform: scale(1.2);
		}
		83.75% {
			transform: scale(0.95);
		}
		86.25% {
			transform: scale(1);
		}
		88.75% {
			transform: scale(0.98);
		}
		91.25% {
			transform: scale(1);
		}
		93.75% {
			transform: scale(1);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes WhiteTiger {
		0% {
			transform: translateY(0);
		}
		9.37% {
			transform: translateY(-0.3125rem);
		}
		18.75% {
			transform: translateY(0);
		}
		21.25% {
			transform: scale(0.78);
		}
		23.75% {
			transform: scale(0.83);
		}
		26.25% {
			transform: scale(0.81);
		}
		28.75% {
			transform: scale(0.83);
		}
		31.25% {
			transform: scale(0.83);
		}
		33.75% {
			transform: scale(1.05);
		}
		36.25% {
			transform: scale(1);
		}
		38.75% {
			transform: scale(1.02);
		}
		41.25% {
			transform: scale(1);
		}
		43.75% {
			transform: scale(1);
		}
		46.25% {
			transform: scale(0.78);
		}
		48.75% {
			transform: scale(0.83);
		}
		51.25% {
			transform: scale(0.81);
		}
		53.75% {
			transform: scale(0.83);
		}
		56.25% {
			transform: scale(0.83);
		}
		58.75% {
			transform: scale(1.05);
		}
		61.25% {
			transform: scale(1);
		}
		63.75% {
			transform: scale(1.02);
		}
		66.25% {
			transform: scale(1);
		}
		68.75% {
			transform: scale(1);
		}
		71.25% {
			transform: scale(0.78);
		}
		73.75% {
			transform: scale(0.83);
		}
		76.25% {
			transform: scale(0.81);
		}
		78.75% {
			transform: scale(0.83);
		}
		81.25% {
			transform: scale(0.83);
		}
		83.75% {
			transform: scale(1.05);
		}
		86.25% {
			transform: scale(1);
		}
		88.75% {
			transform: scale(1.02);
		}
		91.25% {
			transform: scale(1);
		}
		93.75% {
			transform: scale(1);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes VermilionBird {
		0% {
			transform: translateY(0);
		}
		9.37% {
			transform: translateY(0.3125rem);
		}
		18.75% {
			transform: translateY(0);
		}
		21.25% {
			transform: scale(0.78);
		}
		23.75% {
			transform: scale(0.83);
		}
		26.25% {
			transform: scale(0.81);
		}
		28.75% {
			transform: scale(0.83);
		}
		31.25% {
			transform: scale(0.83);
		}
		33.75% {
			transform: scale(1.05);
		}
		36.25% {
			transform: scale(1);
		}
		38.75% {
			transform: scale(1.02);
		}
		41.25% {
			transform: scale(1);
		}
		43.75% {
			transform: scale(1);
		}
		46.25% {
			transform: scale(0.78);
		}
		48.75% {
			transform: scale(0.83);
		}
		51.25% {
			transform: scale(0.81);
		}
		53.75% {
			transform: scale(0.83);
		}
		56.25% {
			transform: scale(0.83);
		}
		58.75% {
			transform: scale(1.05);
		}
		61.25% {
			transform: scale(1);
		}
		63.75% {
			transform: scale(1.02);
		}
		66.25% {
			transform: scale(1);
		}
		68.75% {
			transform: scale(1);
		}
		71.25% {
			transform: scale(0.78);
		}
		73.75% {
			transform: scale(0.83);
		}
		76.25% {
			transform: scale(0.81);
		}
		78.75% {
			transform: scale(0.83);
		}
		81.25% {
			transform: scale(0.83);
		}
		83.75% {
			transform: scale(1.05);
		}
		86.25% {
			transform: scale(1);
		}
		88.75% {
			transform: scale(1.02);
		}
		91.25% {
			transform: scale(1);
		}
		93.75% {
			transform: scale(1);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes BlackTortoise {
		0% {
			transform: translateY(0);
		}
		9.37% {
			transform: translateY(0.3125rem);
		}
		18.75% {
			transform: translateY(0);
		}
		21.25% {
			transform: scale(1.25);
		}
		23.75% {
			transform: scale(1.2);
		}
		26.25% {
			transform: scale(1.22);
		}
		28.75% {
			transform: scale(1.2);
		}
		31.25% {
			transform: scale(1.2);
		}
		33.75% {
			transform: scale(0.95);
		}
		36.25% {
			transform: scale(1);
		}
		38.75% {
			transform: scale(0.98);
		}
		41.25% {
			transform: scale(1);
		}
		43.75% {
			transform: scale(1);
		}
		46.25% {
			transform: scale(1.25);
		}
		48.75% {
			transform: scale(1.2);
		}
		51.25% {
			transform: scale(1.22);
		}
		53.75% {
			transform: scale(1.2);
		}
		56.25% {
			transform: scale(1.2);
		}
		58.75% {
			transform: scale(0.95);
		}
		61.25% {
			transform: scale(1);
		}
		63.75% {
			transform: scale(0.98);
		}
		66.25% {
			transform: scale(1);
		}
		68.75% {
			transform: scale(1);
		}
		71.25% {
			transform: scale(1.25);
		}
		73.75% {
			transform: scale(1.2);
		}
		76.25% {
			transform: scale(1.22);
		}
		78.75% {
			transform: scale(1.2);
		}
		81.25% {
			transform: scale(1.2);
		}
		83.75% {
			transform: scale(0.95);
		}
		86.25% {
			transform: scale(1);
		}
		88.75% {
			transform: scale(0.98);
		}
		91.25% {
			transform: scale(1);
		}
		93.75% {
			transform: scale(1);
		}
		100% {
			transform: scale(1);
		}
	}
`;
export const ZoomSlidingBox = styled(CubeBannerBox)`
	overflow-x: scroll;
	& > * {
		&:nth-child(4n),
		&:nth-child(4n + 1) {
			img {
				width: 80%;
			}
		}
	}
`;
export const ZoomSlidingCardBox = styled("a").withConfig({
	shouldForwardProp: (prop) => !["aspectRatio"].includes(prop),
})<{ aspectRatio?: number }>`
	display: flex;
	min-height: 7.90625rem;
	/* height: 9.1rem; */
	align-items: center;
	justify-content: center;
	width: calc(25vw + 0.1875rem);
	${(props: { aspectRatio?: number }) => {
		if (props.aspectRatio) {
			return css`
				height: calc(((100vw - 1.4rem) / 4) * ${props.aspectRatio});
			`;
		}
	}}
	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
`;

export const ZoomContainer = styled.section`
	display: flex;
	width: 100%;
	align-items: center;
	overflow-x: scroll;
	&::-webkit-scrollbar {
		display: none;
	}
`;
